import React from 'react';
import PropTypes from 'prop-types';
import { withShowHide } from '@sparefoot/react-core/decorators';
import { compose, lifecycle } from 'recompose';
import CSSTransition from 'react-transition-group/CSSTransition';

import './Notification.scss';

export const enhance = compose(
	withShowHide('notification', true),
	lifecycle({
		componentDidMount() {
			setTimeout(this.props.onHideNotification, 10000);
		},
	}),
);
export function Notification({ children, notificationShowing, permanent }) {
	return (
		<CSSTransition
			classNames="transition-fade-in"
			in={notificationShowing}
			unmountOnExit={!permanent}
			timeout={permanent ? null : 150}
		>
			<div className="ss-notification">{children}</div>
		</CSSTransition>
	);
}

Notification.defaultProps = {
	permanent: false,
};

Notification.propTypes = {
	children: PropTypes.node,
	notificationShowing: PropTypes.bool,
	permanent: PropTypes.bool,
};

export default enhance(Notification);
